// prevents empty field when names are null
export const getGenreString = (genres) => {
  if (!genres || !genres.length) {
    return null;
  }

  return genres
    .reduce((acc, { name }) => (name ? [...acc, name] : acc), [])
    .join(', ');
};
